import axios from "@/libs/api.request";

export const getInbound = params => {
  return axios.request({
    url: "/warehouse/b2b",
    method: "get",
    params
  });
};
export const getDetails = id => {
  return axios.request({
    url: `/warehouse/b2b/${id}`,
    method: "GET"
  });
};

export const add = () => {
  console.log(123)
  return axios.request({
    url: "/api/v1/shelves_order/pickup",
    method: "post",
    data: {
      classify: "delivery",
      transfer_number: ["CNB123456789", "CNB87818869"],
      token: "ba5f0f22acfc4cd583038dcac95db217",
      user_id: "1",
      user_name: "abc"
    }
  });
};
